import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { UsoCFDIRedux } from '../Redux/UsoCFDIRedux'

const UsoCFDICrudObservable = createCRUDObservable({
  mainRedux: UsoCFDIRedux,
  reduxPath: 'uso_cfdi',
  dataHandlers: {
    get: response => response.data.data,
  },
})

export const UsoCFDIObservers = Object.assign({}, UsoCFDICrudObservable.observers, {})

export const UsoCFDIEpic = combineEpics(
  UsoCFDICrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/UsoCFDIObservable.js